import { render, staticRenderFns } from "./Actuals.vue?vue&type=template&id=2542d964&"
import script from "./Actuals.vue?vue&type=script&lang=js&"
export * from "./Actuals.vue?vue&type=script&lang=js&"
import style0 from "./Actuals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports